import { Icon, Label, Spinner } from '@iwoca/orion';
import { connect } from 'react-redux';

import { AppDispatch } from '../../../reducers';
import { REMOVE_ERRORED_DOC } from '../actions';
import styles from '../TradingHistory.module.css';
import { UploadedFile } from '../types';

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    removeRejectedFile: (file: UploadedFile) => {
        dispatch({ type: REMOVE_ERRORED_DOC, file: file });
    }
});

const FileStatus = ({
    file,
    removeRejectedFile
}: {
    file: UploadedFile;
    removeRejectedFile: (file: UploadedFile) => void;
}) => {
    const status = file.loading
        ? 'loading'
        : file.hasOwnProperty('error')
        ? 'rejected'
        : 'complete';

    const createfileComponent = () => {
        if (!file.attributes) return null;
        switch (status) {
            case 'complete': {
                return (
                    <div className={styles.fileStatusContainer}>
                        <Icon
                            fill="var(--color-secondary-40)"
                            width={24}
                            height={24}
                            className={styles.fileStatusIcon}
                            icon={'fileWithItemsOutline'}
                        />
                        <Label
                            data-testid={`label-${status}`}
                            className={styles.fileStatus}>
                            {file.attributes['document_name']}
                        </Label>
                    </div>
                );
            }
            case 'rejected':
                return (
                    <div className={styles.fileStatusContainer}>
                        <Icon
                            fill="var(--color-core-40)"
                            width={24}
                            height={24}
                            className={styles.fileStatusIcon}
                            icon={'exclamationTriangleOutline'}
                        />
                        <Label
                            data-testid={`label-${status}`}
                            className={styles.fileStatusError}>
                            {file.attributes['document_name']}
                        </Label>
                        <Icon
                            data-testid="remove-file-button"
                            className={styles.removeFileButton}
                            type="button"
                            fill="var(--color-core-40)"
                            width={24}
                            height={24}
                            icon="timesDefault"
                            onClick={() => removeRejectedFile(file)}
                        />
                    </div>
                );
            case 'loading':
                return (
                    <div className={styles.fileStatusContainer}>
                        <Spinner className={styles.spinnerIcon} size="medium" />
                        <Label
                            data-testid={`label-${status}`}
                            className={styles.fileStatus}>
                            {file.attributes['document_name']}
                        </Label>
                    </div>
                );
            default:
                break;
        }
    };

    return <>{createfileComponent()}</>;
};

export default connect(null, mapDispatchToProps)(FileStatus);
